export default __webpack_public_path__ + "static/media/dark-light-theme-icon.db970e65.svg";